<style>
</style>

<template>
    <div v-if="displayBanner" class="d-flex flex-column align-items-center text-center">
        <div class="col-md-8 alert alert-primary">
            <span class="font-weight-bold">Version {{ assessmentCycle.version.version_number }} ({{ formatDate(assessmentCycle.version.start_date) }} &ndash; {{ formatDate(assessmentCycle.version.end_date) }})</span> &nbsp;&nbsp;
            <span class="badge" :class="'badge-'+assessmentCycle.version.bootstrap_color">{{ assessmentCycle.version.status }}</span>
        </div>
    </div>		
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'

    export default {
        name: "AssessmentCycleVersionBanner",

        props: {
            'assessmentCycle': Object
        },

        data() {
            return {
                // displayBanner: false
            };
        },
        methods: {
            formatDate (date) {
                return date ? moment(date).format('YYYY-MM-DD') : null
            },
            parseStartDate () {
            	return this.cycle.version ? moment(this.cycle.version.start_date).format('YYYY-MM-DD') : ''
            },
            parseEndDate () {
            	return this.cycle.version ? moment(this.cycle.version.end_date).format('YYYY-MM-DD') : ''
            } 
        },

        computed: {
            ...mapState({
                authUserRoles: state => state.followup.authUserRoles,
            }),
            displayBanner() {
                return (this.authUserRoles.includes('Programmer') || this.authUserRoles.includes('Admin'))
            }
        },
        
        mounted () {
            this.$store.dispatch('followup/fetchAuthUserRoles')
        }
    }
</script>
